<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      :moreSearchVisible="true"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        escrowAccountTypeStateOptions: [],
        form: [
          { // 时间
            label: '时间',
            value: 'Time',
            type: 'date',
            placeholder: '请选择时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 账户名称
            label: '账户名称',
            value: 'escrowAccountTypeState',
            type: 'select',
            placeholder: '请选择账户名称',
            default: -1,
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 时间
      if (searchBoxData.Time && searchBoxData.Time.length > 0) {
        searchBoxData.startTime = this.formatDate(searchBoxData.Time[0]);
        searchBoxData.endTime = this.formatDate(searchBoxData.Time[1]);
        delete searchBoxData.Time;
      }
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'ESCROW_ACCOUNT_TYPE',
    });
    this.searchBoxData.escrowAccountTypeStateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
